(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[11],{

/***/ "/Kqh":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"inputBoxWrapper":"_1UHRyj","scrollContainer":"u8pgbn","searchIcon":"DTFokr","span":"_33dvOD","input":"fTNyyb","locations":"KVF-3D"};

/***/ }),

/***/ "1041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _createSvgIcon = _interopRequireDefault(__webpack_require__("8/g6"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Place');

exports.default = _default;

/***/ }),

/***/ "7yCI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _createSvgIcon = _interopRequireDefault(__webpack_require__("8/g6"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'ShoppingCart');

exports.default = _default;

/***/ }),

/***/ "EzDC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _createSvgIcon = _interopRequireDefault(__webpack_require__("8/g6"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
})), 'Train');

exports.default = _default;

/***/ }),

/***/ "HnPO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _createSvgIcon = _interopRequireDefault(__webpack_require__("8/g6"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
})), 'School');

exports.default = _default;

/***/ }),

/***/ "MYoP":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"searchSuggestions":"_1gsRlk","listWrapper":"MKEfuB","suggestionTitle":"_3BpQ2p","suggestionWrapper":"_3rqERS","suggestionRealEstateWrapper":"I7xepQ","activeSuggestion":"CbCgRP","suggestionList":"-znxq9","suggestionListItem":"_1rrXto","poiItem":"_2tGoYH","realEstateSuggestionList":"_3vwA7M","moreResult":"_1Xh-bG","moreBtn":"_1iGa5b"};

/***/ }),

/***/ "NyAi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAccountDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAccountDetailPageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSearchForAgent; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HaE+");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("g33+");





var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_2___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var getAccountDetail = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(accountId) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v2/listing/account/").concat(accountId)).then(function (data) {
              return data.data;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAccountDetail(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getAccountDetailPageData = /*#__PURE__*/function () {
  var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(path) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v2/listing").concat(path)).then(function (data) {
              return data.data;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getAccountDetailPageData(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getSearchForAgent = /*#__PURE__*/function () {
  var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(text) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/search/account/suggest?text=").concat(text)).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getSearchForAgent(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ "Q+9n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _createSvgIcon = _interopRequireDefault(__webpack_require__("8/g6"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Brightness3');

exports.default = _default;

/***/ }),

/***/ "Rme4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _createSvgIcon = _interopRequireDefault(__webpack_require__("8/g6"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Home');

exports.default = _default;

/***/ }),

/***/ "T/J1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("KQm4");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/@material-ui/core/ClickAwayListener/index.js
var ClickAwayListener = __webpack_require__("+qgJ");
var ClickAwayListener_default = /*#__PURE__*/__webpack_require__.n(ClickAwayListener);

// EXTERNAL MODULE: ./src/redux-store/containers/suggestion/index.js + 4 modules
var suggestion = __webpack_require__("xVPZ");

// CONCATENATED MODULE: ./src/utils/search-suggestion/index.js
var flattenSearchSuggestionData = function flattenSearchSuggestionData(data) {
  var normalized = [];
  var dataTypes = ['location', 'poi', 'project', 'projects'];
  dataTypes.map(function (dataType) {
    if (typeof data[dataType] !== 'undefined') {
      data[dataType].map(function (suggestion) {
        normalized.push(suggestion);
      });
    }
  });
  return normalized;
}; // locationTypeList for suggastion type

var locationTypeList = {
  city: 'city',
  districts: 'districts',
  district: 'districts',
  towns: 'towns',
  town: 'towns',
  locality: 'localities',
  localities: 'localities',
  poi: 'poies',
  poies: 'poies',
  poiSet: 'poiSet',
  project: 'sites',
  sites: 'sites',
  projects: 'projects',
  realEstate: 'realEstate'
};
// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events.js
var events = __webpack_require__("tkT3");

// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("17x9");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/react-indiana-drag-scroll/dist/index.es.js



function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

/**
 * BEM class name factory.
 *
 * @typedef {Function} Bem
 * @param {String|Object} [elementOrMods] Element name or hash object with mods
 * @param {Object} [mods] Hash object with mods
 * @returns {String}
 */

/**
 * Returns BEM class name factory.
 *
 * @param {String} componentName Block name
 * @returns {Bem}
 */
var easyBem = function bem(componentName) {
    return function (elementOrMods, mods) {
        if (!elementOrMods) {
            return componentName;
        }

        var element;

        if (typeof elementOrMods === 'string') {
            element = elementOrMods;
        } else {
            mods = elementOrMods;
        }

        if (false) {}

        var base = componentName;
        if (element) {
            base += '__' + element;
        }

        return base + (
            mods
                ? Object.keys(mods).reduce(function (result, name) {
                    var value = mods[name];

                    if (value) {
                        result += ' ' + (
                            typeof value === 'boolean'
                                ? (base + '--' + name)
                                : (base + '--' + name + '_' + value)
                        );
                    }

                    return result;
                }, '')
                : ''
        );
    };
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".indiana-scroll-container--dragging {\r\n  pointer-events: none;\r\n  cursor: grab;\r\n}\r\n\r\n.indiana-dragging {\r\n  cursor: grab !important;\r\n}";
styleInject(css);

var index_es_classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var index_es_createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var index_es_inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var index_es_possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var cn = easyBem('indiana-scroll-container');

var index_es_ScrollContainer = function (_Component) {
  index_es_inherits(ScrollContainer, _Component);

  function ScrollContainer(props) {
    index_es_classCallCheck(this, ScrollContainer);

    var _this = index_es_possibleConstructorReturn(this, (ScrollContainer.__proto__ || Object.getPrototypeOf(ScrollContainer)).call(this, props));

    _this.onTouchStart = function (e) {
      if (_this.isDraggable(e.target)) {
        var touch = e.touches[0];
        _this.pressed = true;
        _this.clientX = touch.clientX;
        _this.clientY = touch.clientY;
        e.stopPropagation();
      }
    };

    _this.onTouchEnd = function (e) {
      _this.processEnd();
    };

    _this.onTouchMove = function (e) {
      if (_this.pressed) {
        var touch = e.touches[0];
        if (touch) {
          _this.processMove(touch.clientX, touch.clientY);
          if (e.preventDefault) {
            e.preventDefault();
          }
        }
      }
    };

    _this.onMouseDown = function (e) {
      if (_this.isDraggable(e.target)) {
        _this.pressed = true;
        _this.clientX = e.clientX;
        _this.clientY = e.clientY;

        e.stopPropagation();
      }
    };

    _this.onMouseMove = function (e) {
      if (_this.pressed) {
        _this.processMove(e.clientX, e.clientY, e);
        if (e.preventDefault) {
          e.preventDefault();
        }
      }
    };

    _this.onMouseUp = function (e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
      e.stopPropagation();

      _this.processEnd();
    };

    _this.container = react_default.a.createRef();
    return _this;
  }

  index_es_createClass(ScrollContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('mouseup', this.onMouseUp);
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('touchmove', this.onTouchMove);
      window.addEventListener('touchend', this.onTouchEnd);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('mouseup', this.onMouseUp);
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('touchmove', this.onTouchMove);
      window.removeEventListener('touchend', this.onTouchEnd);
    }
  }, {
    key: 'isDraggable',
    value: function isDraggable(target) {
      var ignoreElements = this.props.ignoreElements;
      if (ignoreElements) {
        var closest = target.closest(ignoreElements);
        return closest === null || closest.contains(this.getElement());
      } else {
        return true;
      }
    }
  }, {
    key: 'getElement',
    value: function getElement() {
      return this.container.current;
    }
  }, {
    key: 'processMove',
    value: function processMove(newClientX, newClientY) {
      var _props = this.props,
          horizontal = _props.horizontal,
          vertical = _props.vertical,
          activationDistance = _props.activationDistance,
          onScroll = _props.onScroll,
          onStartScroll = _props.onStartScroll;


      var container = this.container.current;

      if (!this.dragging && this.pressed) {
        if (horizontal && Math.abs(newClientX - this.clientX) > activationDistance || vertical && Math.abs(newClientY - this.clientY) > activationDistance) {
          this.clientX = newClientX;
          this.clientY = newClientY;
          this.dragging = true;
          document.body.classList.add('indiana-dragging');
          if (onStartScroll) {
            onStartScroll();
          }
          this.forceUpdate();
        }
      }
      if (this.dragging) {
        if (horizontal) {
          container.scrollLeft -= newClientX - this.clientX;
        }
        if (vertical) {
          container.scrollTop -= newClientY - this.clientY;
        }

        if (onScroll) {
          onScroll(container.scrollLeft, container.scrollTop, container.scrollWidth, container.scrollHeight);
        }

        this.clientX = newClientX;
        this.clientY = newClientY;
      }
    }
  }, {
    key: 'processEnd',
    value: function processEnd() {
      var onEndScroll = this.props.onEndScroll;


      var container = this.container.current;

      this.pressed = false;
      this.dragging = false;

      document.body.classList.remove('indiana-dragging');

      if (onEndScroll) {
        onEndScroll(container.scrollLeft, container.scrollTop, container.scrollWidth, container.scrollHeight);
      }

      this.forceUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          style = _props2.style,
          hideScrollbars = _props2.hideScrollbars;


      return react_default.a.createElement(
        'div',
        {
          className: classnames(className, cn({ dragging: this.dragging })),
          style: _extends({}, style, { overflow: hideScrollbars ? 'hidden' : 'auto' }),
          ref: this.container,
          onTouchStart: this.onTouchStart,
          onMouseDown: this.onMouseDown
        },
        children
      );
    }
  }]);
  return ScrollContainer;
}(react["Component"]);

index_es_ScrollContainer.propTypes = {
  vertical: prop_types_default.a.bool,
  horizontal: prop_types_default.a.bool,
  hideScrollbars: prop_types_default.a.bool,
  activationDistance: prop_types_default.a.number,
  children: prop_types_default.a.node,
  onStartScroll: prop_types_default.a.func,
  onScroll: prop_types_default.a.func,
  onEndScroll: prop_types_default.a.func,
  className: prop_types_default.a.string,
  style: prop_types_default.a.object,
  ignoreElements: prop_types_default.a.string
};
index_es_ScrollContainer.defaultProps = {
  hideScrollbars: true,
  activationDistance: 10,
  vertical: true,
  horizontal: true,
  style: {}
};

/* harmony default export */ var index_es = (index_es_ScrollContainer);
//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);

// EXTERNAL MODULE: ./src/components/e6t/listing/listing-filter/suggestion-box/input-box/styles.module.scss
var styles_module = __webpack_require__("/Kqh");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/e6t/listing/listing-filter/suggestion-box/input-box/index.jsx


var input_box_this = undefined;

var __jsx = react_default.a.createElement;






var input_box_renderLocations = function renderLocations(locations, onRemove) {
  var locationList = [];
  var locationKeys = Object.keys(locations);
  locationKeys.forEach(function (locationKey) {
    if (locations[locationKey]) {
      if (locationKey === 'city') {
        locations[locationKey].type = locationKey;
        locations[locationKey].id && locationList.push(locations[locationKey]);
      } else if (!['key', 'singleTown', 'singleDistrict'].includes(locationKey) && locations[locationKey].length > 0) {
        locations[locationKey].forEach(function (location) {
          location.type = locationKey;
          locationList.push(location);
        });
      }
    }
  });
  return locationList.reverse().map(function (location) {
    var isProject = location.type === 'project';
    var displayedName = isProject ? location.displayName : location.displayName || (location === null || location === void 0 ? void 0 : location.name);
    return __jsx("div", {
      className: styles_module_default.a.locations,
      key: location.id
    }, __jsx("span", null, displayedName), __jsx(desktop_elements["e" /* Icon */], {
      "data-test-selector": "listing-filter-search-cancel-icon",
      name: "cancel",
      onClick: onRemove.bind(input_box_this, location)
    }));
  });
};

var input_box_InputBox = function InputBox(_ref) {
  var onChange = _ref.onChange,
      locations = _ref.locations,
      onRemove = _ref.onRemove,
      onKeyDown = _ref.onKeyDown,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      dataEjCategory = _ref['data-ej-category'],
      dataEjAction = _ref['data-ej-action'],
      dataEjLabel = _ref['data-ej-label'];
  var scrollBarStyles = classnames_default()(Object(defineProperty["default"])({
    'scroll-container': true
  }, styles_module_default.a.scrollContainer, true));
  return __jsx("div", {
    className: styles_module_default.a.inputBoxWrapper
  }, __jsx(index_es, {
    className: scrollBarStyles,
    vertical: false,
    horizontal: true,
    hideScrollbars: true,
    ignoreElements: "input"
  }, __jsx("input", {
    type: "text" // style={{ minWidth: inputWidth }}
    ,
    className: styles_module_default.a.input,
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    onBlur: onBlur,
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": dataEjLabel,
    "data-test-selector": "listing-filter-search-inputbox"
  }), locations && Object.keys(locations).length > 0 ? input_box_renderLocations(locations, onRemove) : null));
};

/* harmony default export */ var input_box = (input_box_InputBox);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/index.js
var styles = __webpack_require__("SUMQ");

// EXTERNAL MODULE: ./src/utils/ui/index.js
var ui = __webpack_require__("PdCH");

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ShoppingBasket.js
var ShoppingBasket = __webpack_require__("XoTF");
var ShoppingBasket_default = /*#__PURE__*/__webpack_require__.n(ShoppingBasket);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/School.js
var School = __webpack_require__("HnPO");
var School_default = /*#__PURE__*/__webpack_require__.n(School);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ShoppingCart.js
var ShoppingCart = __webpack_require__("7yCI");
var ShoppingCart_default = /*#__PURE__*/__webpack_require__.n(ShoppingCart);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Brightness3.js
var Brightness3 = __webpack_require__("Q+9n");
var Brightness3_default = /*#__PURE__*/__webpack_require__.n(Brightness3);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Train.js
var Train = __webpack_require__("EzDC");
var Train_default = /*#__PURE__*/__webpack_require__.n(Train);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Place.js
var Place = __webpack_require__("1041");
var Place_default = /*#__PURE__*/__webpack_require__.n(Place);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Home.js
var Home = __webpack_require__("Rme4");
var Home_default = /*#__PURE__*/__webpack_require__.n(Home);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/PersonOutlined.js
var PersonOutlined = __webpack_require__("gsAU");
var PersonOutlined_default = /*#__PURE__*/__webpack_require__.n(PersonOutlined);

// EXTERNAL MODULE: ./src/components/e6t/listing/listing-filter/suggestion-box/suggestion/styles.module.scss
var suggestion_styles_module = __webpack_require__("MYoP");
var suggestion_styles_module_default = /*#__PURE__*/__webpack_require__.n(suggestion_styles_module);

// CONCATENATED MODULE: ./src/components/e6t/listing/listing-filter/suggestion-box/suggestion/index.jsx


var suggestion_jsx = react_default.a.createElement;










var getSuggestionTitle = function getSuggestionTitle(type) {
  var title;

  switch (type) {
    case 'location':
      title = 'İl-İlçe-Semt-Mahalle';
      break;

    case 'poi':
      title = 'Yakınında Ara';
      break;

    case 'projects':
      title = 'Projeler';
      break;

    case 'project':
      title = 'Siteler';
      break;

    case 'realEstate':
      title = 'Emlak Ofisleri';
      break;

    default:
      title = '';
      break;
  }

  return title;
};

var suggestion_getPoiIcon = function getPoiIcon(poiCategory) {
  var icon;

  switch (poiCategory) {
    case 1:
      icon = ShoppingBasket_default.a; // Alışveriş Merkezi

      break;

    case 2:
      icon = School_default.a; // Eğitim Kurumları

      break;

    case 7:
      icon = ShoppingCart_default.a; // Marketler

      break;

    case 8:
      icon = Brightness3_default.a; // Sağlık Kurumları

      break;

    case 11:
      icon = Train_default.a; // Ulaşım

      break;

    default:
      icon = Train_default.a;
      break;
  }

  var RedIcon = Object(styles["withStyles"])({
    root: {
      color: '#e16e6b',
      marginRight: '8px',
      transform: poiCategory === 8 ? 'rotate(180deg)' : null
    }
  })(icon);
  return suggestion_jsx(RedIcon, null);
};

var suggestion_SuggestionIcon = function SuggestionIcon(_ref) {
  var type = _ref.type,
      item = _ref.item;

  switch (type) {
    case 'location':
      return suggestion_jsx(Place_default.a, {
        style: {
          marginRight: '8px'
        }
      });

    case 'poi':
      return suggestion_getPoiIcon(item.categoryId);

    case 'projects':
      return suggestion_jsx(Home_default.a, {
        style: {
          marginRight: '8px'
        }
      });

    case 'project':
      return suggestion_jsx(Home_default.a, {
        style: {
          marginRight: '8px'
        }
      });

    case 'realEstate':
      return suggestion_jsx(PersonOutlined_default.a, {
        style: {
          marginRight: '8px'
        }
      });

    default:
      return suggestion_jsx(Home_default.a, {
        style: {
          marginRight: '8px'
        }
      });
  }
};

var suggestion_SearchSuggestionItem = function SearchSuggestionItem(_ref2) {
  var type = _ref2.type,
      data = _ref2.data,
      _onClick = _ref2.onClick,
      highlightText = _ref2.highlightText,
      activeItemId = _ref2.activeItemId;
  return data.map(function (item) {
    var _classnames;

    var wrapperClasses = classnames_default()((_classnames = {}, Object(defineProperty["default"])(_classnames, suggestion_styles_module_default.a.suggestionWrapper, true), Object(defineProperty["default"])(_classnames, suggestion_styles_module_default.a.suggestionRealEstateWrapper, type === 'realEstate'), Object(defineProperty["default"])(_classnames, suggestion_styles_module_default.a.activeSuggestion, item.id === activeItemId), _classnames));
    return suggestion_jsx("div", {
      className: wrapperClasses,
      key: item.id,
      onClick: function onClick() {
        return _onClick(item);
      },
      "data-test-selector": "suggestion-list-item-".concat(item.displayedName || (item === null || item === void 0 ? void 0 : item.name))
    }, suggestion_jsx("span", {
      className: suggestion_styles_module_default.a.suggestionListItem
    }, suggestion_jsx(suggestion_SuggestionIcon, {
      type: type,
      item: item
    }), suggestion_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: Object(ui["b" /* highlightParagraph */])(item.displayedName || (item === null || item === void 0 ? void 0 : item.name), highlightText)
      }
    }), item.displayedAddress ? " (".concat(item.displayedAddress, ") ") : ''));
  });
};

var suggestion_SearchSuggestionList = function SearchSuggestionList(_ref3) {
  var type = _ref3.type,
      data = _ref3.data,
      onClick = _ref3.onClick,
      highlightText = _ref3.highlightText,
      selectedItemIndex = _ref3.selectedItemIndex;

  if (data) {
    var _flattenedData$select, _classnames2;

    // Manupulate data to single level array
    // Find currentlySelectedItem in it
    // Send currentlySelectedItem's id to SearchSuggestionItem
    var _useState = Object(react["useState"])(false),
        moreResult = _useState[0],
        setMoreResult = _useState[1];

    var flattenedData = flattenSearchSuggestionData(data);
    var activeItemId = selectedItemIndex !== null ? (_flattenedData$select = flattenedData[selectedItemIndex]) === null || _flattenedData$select === void 0 ? void 0 : _flattenedData$select.id : null;
    var currentTypeData = data[type];
    var moreResultClass = classnames_default()((_classnames2 = {}, Object(defineProperty["default"])(_classnames2, suggestion_styles_module_default.a.suggestionList, true), Object(defineProperty["default"])(_classnames2, suggestion_styles_module_default.a.realEstateSuggestionList, type === 'realEstate' && (currentTypeData === null || currentTypeData === void 0 ? void 0 : currentTypeData.length) > 5), Object(defineProperty["default"])(_classnames2, suggestion_styles_module_default.a.moreResult, moreResult), _classnames2));

    if (currentTypeData && (currentTypeData === null || currentTypeData === void 0 ? void 0 : currentTypeData.length) > 0) {
      var title = getSuggestionTitle(type);
      return suggestion_jsx("div", {
        className: suggestion_styles_module_default.a.listWrapper
      }, suggestion_jsx("div", {
        className: suggestion_styles_module_default.a.suggestionTitle,
        "data-test-selector": "suggestion-list-".concat(title)
      }, suggestion_jsx("p", null, title)), suggestion_jsx("div", {
        className: moreResultClass
      }, suggestion_SearchSuggestionItem({
        type: type,
        data: currentTypeData || data,
        onClick: onClick,
        highlightText: highlightText,
        activeItemId: activeItemId
      })), type === 'realEstate' && moreResult === false && (currentTypeData === null || currentTypeData === void 0 ? void 0 : currentTypeData.length) > 5 && suggestion_jsx("div", {
        className: suggestion_styles_module_default.a.moreBtn,
        onClick: function onClick() {
          return setMoreResult(true);
        }
      }, "Di\u011Fer Sonu\xE7lar\u0131 G\xF6r ", suggestion_jsx(desktop_elements["e" /* Icon */], {
        name: "expand_more"
      })));
    }

    return null;
  }

  return null;
};

var suggestion_redirectToUrl = function redirectToUrl(item, tradeTypeSlug) {
  tradeTypeSlug && Object(events["Q" /* searchGTMEvents */])({
    action: "".concat(tradeTypeSlug, "-projeler"),
    label: item === null || item === void 0 ? void 0 : item.name,
    category: 'search'
  });
  if (item.url) window.location.href = item.url;
};

var suggestion_SearchSuggestion = function SearchSuggestion(_ref4) {
  var _suggestions$;

  var suggestions = _ref4.suggestions,
      addSuggestion = _ref4.addSuggestion,
      highlightText = _ref4.highlightText,
      selectedItemIndex = _ref4.selectedItemIndex,
      tradeTypeSlug = _ref4.tradeTypeSlug;
  var realEstateSuggestions = [];

  if (((_suggestions$ = suggestions[0]) === null || _suggestions$ === void 0 ? void 0 : _suggestions$.key) === 'account') {
    suggestions.map(function (item) {
      var _realEstateSuggestion;

      return (_realEstateSuggestion = realEstateSuggestions).push.apply(_realEstateSuggestion, Object(toConsumableArray["a" /* default */])(item.records));
    });
    realEstateSuggestions = {
      realEstate: realEstateSuggestions
    };
  }

  return suggestion_jsx("div", {
    className: suggestion_styles_module_default.a.searchSuggestions
  }, suggestion_jsx(suggestion_SearchSuggestionList, {
    key: 0,
    type: "location",
    data: suggestions,
    onClick: addSuggestion,
    highlightText: highlightText,
    selectedItemIndex: selectedItemIndex
  }), suggestion_jsx(suggestion_SearchSuggestionList, {
    key: 1,
    type: "poi",
    data: suggestions,
    onClick: addSuggestion,
    highlightText: highlightText,
    selectedItemIndex: selectedItemIndex
  }), suggestion_jsx(suggestion_SearchSuggestionList, {
    key: 2,
    type: "project",
    data: suggestions,
    onClick: addSuggestion,
    highlightText: highlightText,
    selectedItemIndex: selectedItemIndex
  }), suggestion_jsx(suggestion_SearchSuggestionList, {
    key: 3,
    type: "projects",
    data: suggestions,
    highlightText: highlightText,
    onClick: function onClick(item) {
      return suggestion_redirectToUrl(item, tradeTypeSlug);
    },
    selectedItemIndex: selectedItemIndex
  }), suggestion_jsx(suggestion_SearchSuggestionList, {
    key: 4,
    type: "realEstate",
    data: realEstateSuggestions,
    highlightText: highlightText,
    onClick: suggestion_redirectToUrl,
    selectedItemIndex: selectedItemIndex,
    placeholder: "Emlak Ofisleri"
  }));
};

/* harmony default export */ var suggestion_box_suggestion = (suggestion_SearchSuggestion);
// CONCATENATED MODULE: ./src/components/e6t/listing/listing-filter/suggestion-box/index.jsx








var suggestion_box_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }











var suggestion_box_SuggestionBox = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(SuggestionBox, _Component);

  var _super = _createSuper(SuggestionBox);

  function SuggestionBox(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, SuggestionBox);

    _this = _super.call(this, props);

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleInputOnChange", function (e) {
      var _filters$category, _filters$category$cat, _filters$category2, _filters$category2$tr;

      var _this$props = _this.props,
          callSuggestionWithoutTabId = _this$props.callSuggestionWithoutTabId,
          useTab = _this$props.useTab,
          onTextChange = _this$props.onTextChange,
          searchType = _this$props.searchType,
          filters = _this$props.filters;
      var activeSearchType = useTab || searchType === 'realEstate' && 'Emlak Ofisleri';
      var activeCategoryId = filters === null || filters === void 0 ? void 0 : (_filters$category = filters.category) === null || _filters$category === void 0 ? void 0 : (_filters$category$cat = _filters$category.category) === null || _filters$category$cat === void 0 ? void 0 : _filters$category$cat.id;
      var activeTradeTypeId = filters === null || filters === void 0 ? void 0 : (_filters$category2 = filters.category) === null || _filters$category2 === void 0 ? void 0 : (_filters$category2$tr = _filters$category2.tradeType) === null || _filters$category2$tr === void 0 ? void 0 : _filters$category2$tr.id;
      var inputText = e.target.value;

      _this.setState({
        inputText: inputText,
        isOpen: inputText && inputText.length > 2,
        selectedItemIndex: null
      });

      var searchBoxTokens = _this.state.searchBoxTokens;
      setTimeout(function () {
        if (inputText && inputText.length > 2) {
          var _searchBoxTokens$city, _searchBoxTokens$loca, _searchBoxTokens$loca2, _searchBoxTokens$dist, _searchBoxTokens$loca3, _searchBoxTokens$loca4;

          var cityId = (searchBoxTokens === null || searchBoxTokens === void 0 ? void 0 : (_searchBoxTokens$city = searchBoxTokens.city) === null || _searchBoxTokens$city === void 0 ? void 0 : _searchBoxTokens$city.id) || (searchBoxTokens === null || searchBoxTokens === void 0 ? void 0 : (_searchBoxTokens$loca = searchBoxTokens.location) === null || _searchBoxTokens$loca === void 0 ? void 0 : (_searchBoxTokens$loca2 = _searchBoxTokens$loca.city) === null || _searchBoxTokens$loca2 === void 0 ? void 0 : _searchBoxTokens$loca2.id);
          var districtId = (searchBoxTokens === null || searchBoxTokens === void 0 ? void 0 : (_searchBoxTokens$dist = searchBoxTokens.districts) === null || _searchBoxTokens$dist === void 0 ? void 0 : _searchBoxTokens$dist.cityId) || (searchBoxTokens === null || searchBoxTokens === void 0 ? void 0 : (_searchBoxTokens$loca3 = searchBoxTokens.location) === null || _searchBoxTokens$loca3 === void 0 ? void 0 : (_searchBoxTokens$loca4 = _searchBoxTokens$loca3.districts) === null || _searchBoxTokens$loca4 === void 0 ? void 0 : _searchBoxTokens$loca4.cityId);
          var selectLocation = cityId || districtId;
          callSuggestionWithoutTabId(inputText, selectLocation, activeCategoryId, activeTradeTypeId, activeSearchType);
        }
      }, 0);
      onTextChange && onTextChange(inputText);
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "prepareLocationObject", function (location) {
      var resolveSearchBoxTokens = _objectSpread({}, _this.state.searchBoxTokens);

      if (location.type === 'city') {
        delete location.criteria;
        resolveSearchBoxTokens.city = location;
      } else {
        if (Object.keys(location).includes('city')) {
          resolveSearchBoxTokens.city = location.city;
        }

        if (Object.keys(location).includes('district')) {
          resolveSearchBoxTokens.districts = resolveSearchBoxTokens.districts ? Object(toConsumableArray["a" /* default */])(resolveSearchBoxTokens.districts) : [];
          resolveSearchBoxTokens.districts.push(location === null || location === void 0 ? void 0 : location.district);
          var noDuplicateDistricts = resolveSearchBoxTokens.districts.reduce(function (acc, currentValue) {
            var item = acc.find(function (district) {
              return district.id === currentValue.id;
            });

            if (!item) {
              return [].concat(Object(toConsumableArray["a" /* default */])(acc), [currentValue]);
            }

            return acc;
          }, []);
          resolveSearchBoxTokens.districts = noDuplicateDistricts;
        }

        resolveSearchBoxTokens[locationTypeList[location.type]] = resolveSearchBoxTokens[locationTypeList[location.type]] || [];
        var indexOnArray = resolveSearchBoxTokens[locationTypeList[location.type]].map(function (item) {
          return item.id;
        }).indexOf(location.id); // // add if it does not exists already

        if (indexOnArray < 0) {
          delete location.criteria;

          if (location.type === 'poi' || location.type === 'poies') {
            var poiList = resolveSearchBoxTokens[locationTypeList[location.type]];
            poiList.push(location);
            resolveSearchBoxTokens = {
              poies: poiList
            };
          } else {
            if (Object.keys(resolveSearchBoxTokens).includes('poies') || Object.keys(resolveSearchBoxTokens).includes('poi')) {
              delete resolveSearchBoxTokens.poi;
              delete resolveSearchBoxTokens.poies;
            }

            resolveSearchBoxTokens[locationTypeList[location.type]].push(location);
          }
        }
      }

      return resolveSearchBoxTokens;
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "addLocation", function (location) {
      var onLocationChange = _this.props.onLocationChange;

      var convertedSearchBoxTokens = _this.prepareLocationObject(location);

      _this.setState({
        searchBoxTokens: convertedSearchBoxTokens,
        inputText: '',
        isOpen: false,
        selectedItemIndex: null
      }, function () {
        if (onLocationChange) {
          onLocationChange('', convertedSearchBoxTokens);
        }
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "removeLocation", function (location) {
      var _this$state = _this.state,
          searchBoxTokens = _this$state.searchBoxTokens,
          inputText = _this$state.inputText;
      var onLocationChange = _this.props.onLocationChange;

      if (location.type === 'city') {
        searchBoxTokens.city = {};
      } else {
        var _searchBoxTokens$loca5, _searchBoxTokens$loca6;

        searchBoxTokens[locationTypeList[location.type]] = (_searchBoxTokens$loca5 = searchBoxTokens[locationTypeList[location.type]]) === null || _searchBoxTokens$loca5 === void 0 ? void 0 : _searchBoxTokens$loca5.filter(function (item) {
          return item.id !== location.id;
        });

        if (!((_searchBoxTokens$loca6 = searchBoxTokens[locationTypeList[location.type]]) === null || _searchBoxTokens$loca6 === void 0 ? void 0 : _searchBoxTokens$loca6.length)) {
          delete searchBoxTokens[locationTypeList[location.type]];
        }
      }

      _this.setState(function () {
        return {
          searchBoxTokens: searchBoxTokens
        };
      }, function () {
        onLocationChange(inputText, searchBoxTokens);
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (event) {
      var onSearchTriggered = _this.props.onSearchTriggered;
      var _this$state2 = _this.state,
          searchBoxTokens = _this$state2.searchBoxTokens,
          inputText = _this$state2.inputText,
          selectedItemIndex = _this$state2.selectedItemIndex; // redirect directly to listing results when the user presses Enter

      if (event.key === 'Enter' && selectedItemIndex === null) {
        onSearchTriggered && onSearchTriggered(inputText);
      } // remove the location with last index from search box when the user presses Backspace
      else if (event.key === 'Backspace') {
          if (searchBoxTokens.length > 0 && inputText.length < 1) {
            _this.removeLocation(searchBoxTokens.slice(-1).pop());
          }
        } // prevent input indicator position change when these buttons pressed
        else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
          }
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "onSearchPressed", function () {
      var onSearchTriggered = _this.props.onSearchTriggered;
      var inputText = _this.state.inputText;
      onSearchTriggered && onSearchTriggered(inputText);
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleSuggestionBoxClickAway", function () {
      _this.setState({
        isOpen: false
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleKeyboardEvents", function (e) {
      var isOpen = _this.state.isOpen;

      if (isOpen) {
        if (e.code === 'ArrowUp') {
          _this.handleArrowUpKey();
        } else if (e.code === 'ArrowDown') {
          _this.handleArrowDownKey();
        } else if (e.code === 'Enter') {
          _this.handleEnterKey();
        }
      }
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleArrowUpKey", function () {
      var suggestionData = _this.props.suggestionData;
      var selectedItemIndex = _this.state.selectedItemIndex;
      var flattenedData = flattenSearchSuggestionData(suggestionData);

      if (flattenedData.length !== 0 && selectedItemIndex !== 0) {
        if (selectedItemIndex === null) {
          selectedItemIndex = 0;
        } else {
          // eslint-disable-next-line no-plusplus
          selectedItemIndex--;
        }
      }

      _this.setState({
        selectedItemIndex: selectedItemIndex
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleArrowDownKey", function () {
      var suggestionData = _this.props.suggestionData;
      var selectedItemIndex = _this.state.selectedItemIndex;
      var flattenedData = flattenSearchSuggestionData(suggestionData);

      if (flattenedData.length !== 0) {
        if (selectedItemIndex === null) {
          selectedItemIndex = 0;
        } else {
          // eslint-disable-next-line no-lonely-if
          if (selectedItemIndex < flattenedData.length - 1) {
            // eslint-disable-next-line no-plusplus
            selectedItemIndex++;
          }
        }
      }

      _this.setState({
        selectedItemIndex: selectedItemIndex
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleEnterKey", function () {
      var _this$props2 = _this.props,
          suggestionData = _this$props2.suggestionData,
          useTab = _this$props2.useTab;
      var selectedItemIndex = _this.state.selectedItemIndex;
      var flattenedData = flattenSearchSuggestionData(suggestionData);

      if (selectedItemIndex !== null) {
        var selectedItem = flattenedData[selectedItemIndex];

        if (selectedItem.type === 'projects') {
          if (selectedItem.slug) {
            Object(events["Q" /* searchGTMEvents */])({
              action: "".concat(useTab.slug, "-projeler"),
              label: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name
            });
            window.top.location.href = selectedItem.slug;
          }
        } else {
          _this.addLocation(flattenedData[selectedItemIndex]);
        }
      }
    });

    var resolvedFilters = props.filters;

    var _searchBoxTokens = (resolvedFilters === null || resolvedFilters === void 0 ? void 0 : resolvedFilters.location) || {};

    _this.state = {
      isOpen: false,
      searchBoxTokens: _searchBoxTokens,
      inputText: '',
      selectedItemIndex: null
    };
    return _this;
  }

  Object(createClass["a" /* default */])(SuggestionBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyboardEvents, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var resolvedFilters = this.props.filters;

      var isEqual = lodash_default.a.isEqual(resolvedFilters, prevProps.filters);

      if (resolvedFilters && !isEqual) {
        var searchBoxTokens = (resolvedFilters === null || resolvedFilters === void 0 ? void 0 : resolvedFilters.location) || {}; // eslint-disable-next-line react/no-did-update-set-state

        this.setState({
          searchBoxTokens: searchBoxTokens
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyboardEvents, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _filters$category3, _filters$freetext, _searchBoxTokens$poie;

      var _this$state3 = this.state,
          searchBoxTokens = _this$state3.searchBoxTokens,
          isOpen = _this$state3.isOpen,
          selectedItemIndex = _this$state3.selectedItemIndex;
      var _this$props3 = this.props,
          suggestionData = _this$props3.suggestionData,
          placeholder = _this$props3.placeholder,
          onFocus = _this$props3.onFocus,
          onBlur = _this$props3.onBlur,
          page = _this$props3.page,
          useTab = _this$props3.useTab,
          filters = _this$props3.filters;

      var _ref = (filters === null || filters === void 0 ? void 0 : (_filters$category3 = filters.category) === null || _filters$category3 === void 0 ? void 0 : _filters$category3.tradeType) || {},
          name = _ref.name;

      var inputText = filters === null || filters === void 0 ? void 0 : (_filters$freetext = filters.freetext) === null || _filters$freetext === void 0 ? void 0 : _filters$freetext.value;
      var tradeTypeEquals = {
        Satılık: 'satilik',
        Kiralık: 'kiralik',
        Projeler: 'projeler'
      };
      var hidePlaceholder = searchBoxTokens.city || ((_searchBoxTokens$poie = searchBoxTokens.poies) === null || _searchBoxTokens$poie === void 0 ? void 0 : _searchBoxTokens$poie.length) > 0;
      return suggestion_box_jsx(react_default.a.Fragment, null, suggestion_box_jsx(input_box, {
        locations: searchBoxTokens,
        onRemove: this.removeLocation,
        onChange: this.handleInputOnChange,
        onFocus: onFocus,
        onBlur: onBlur,
        value: inputText,
        onKeyDown: this.onKeyDown,
        placeholder: hidePlaceholder ? '' : placeholder
      }), suggestionData.length !== 0 && isOpen && suggestion_box_jsx(ClickAwayListener_default.a, {
        onClickAway: this.handleSuggestionBoxClickAway
      }, suggestion_box_jsx(suggestion_box_suggestion, {
        suggestions: suggestionData,
        addSuggestion: this.addLocation,
        highlightText: inputText,
        selectedItemIndex: selectedItemIndex,
        tradeTypeSlug: tradeTypeEquals[useTab] || tradeTypeEquals[name] || 'satilik'
      })));
    }
  }]);

  return SuggestionBox;
}(react["Component"]);

/* harmony default export */ var suggestion_box = __webpack_exports__["a"] = (es["b" /* connect */].apply(void 0, Object(toConsumableArray["a" /* default */])(suggestion["a" /* default */]))(suggestion_box_SuggestionBox));

/***/ }),

/***/ "XoTF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _createSvgIcon = _interopRequireDefault(__webpack_require__("8/g6"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'ShoppingBasket');

exports.default = _default;

/***/ }),

/***/ "xVPZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/@emlakjet/services/index.js
var services = __webpack_require__("wvVG");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("vDqi");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__("mOvS");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./services/suggestion.js





var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var tokenSource = null;
var getSearchWithSuggestion = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
    var text, cityId, categoryId, tradeTypeId;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            text = _ref.text, cityId = _ref.cityId, categoryId = _ref.categoryId, tradeTypeId = _ref.tradeTypeId;

            // cancel  previous ajax if exists
            if (tokenSource) {
              tokenSource.cancel();
            }

            tokenSource = axios_default.a.CancelToken.source();
            return _context.abrupt("return", axios_default.a.get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/search/suggest/").concat(text), {
              cancelToken: tokenSource.token,
              headers: {
                'X-From-Channel': 'DESKTOP_WEB'
              },
              params: {
                categoryId: categoryId,
                tradeTypeId: tradeTypeId,
                cityId: cityId
              }
            }).then(function (response) {
              return response.data;
            })["catch"](function (error) {
              if (axios_default.a.isCancel(error)) {
                return new Error('Request canceled by axios cancel token');
              }

              return new Error('An error occured');
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getSearchWithSuggestion(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getSearchWithProjectSuggestion = /*#__PURE__*/function () {
  var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref3) {
    var text;
    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            text = _ref3.text;

            if (tokenSource) {
              tokenSource.cancel();
            }

            tokenSource = axios_default.a.CancelToken.source();
            return _context2.abrupt("return", axios_default.a.get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/search/project/suggest/").concat(text), {
              cancelToken: tokenSource.token,
              headers: {
                'X-From-Channel': 'DESKTOP_WEB'
              }
            }).then(function (response) {
              return response.data;
            })["catch"](function (error) {
              if (axios_default.a.isCancel(error)) {
                return new Error('Request canceled by axios cancel token');
              }

              return new Error('An error occured');
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getSearchWithProjectSuggestion(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// CONCATENATED MODULE: ./src/utils/suggestion/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var typeList = {
  CITY: 'city',
  DISTRICT: 'district',
  TOWN: 'town',
  LOCALITY: 'locality',
  POI: 'poi',
  poi: 'poi',
  site: 'project',
  project: 'projects',
  projects: 'projects',
  city: 'city',
  district: 'district',
  town: 'town',
  locality: 'locality'
};
var convertSuggestionDataForFilterBox = function convertSuggestionDataForFilterBox(response) {
  var _response$result;

  if (!(response === null || response === void 0 ? void 0 : (_response$result = response.result) === null || _response$result === void 0 ? void 0 : _response$result.suggestions)) return [];
  var data = {};
  var suggestions = response.result.suggestions;
  suggestions.forEach(function (suggestion) {
    var prefix = suggestion.key === 'site' ? 'project' : suggestion.key;
    data[prefix] = suggestion.records.length > 0 ? suggestion.records.map(function (record) {
      return _objectSpread(_objectSpread({}, record), {}, {
        displayedName: record.name,
        type: typeList[record.type || suggestion.key]
      });
    }) : [];
  });
  return data;
};
// EXTERNAL MODULE: ./services/account.js
var account = __webpack_require__("NyAi");

// CONCATENATED MODULE: ./src/redux-store/action-types/suggestion.js
var SUGGESTION_LOADING = 'SUGGESTION_LOADING';
var SUGGESTION_LOAD = 'SUGGESTION_LOAD';
var SUGGESTION_ERROR = 'SUGGESTION_ERROR';
// CONCATENATED MODULE: ./src/redux-store/actions/suggestion.js







/*
  make a single api caller instance
  for cancelling previous call
  when a repetitive call exists
 */

var apiCaller = null;
var suggestion_getSuggestion = function getSuggestion(text, fields, cityId) {
  return /*#__PURE__*/function () {
    var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(dispatch) {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: SUGGESTION_LOADING,
                payload: {
                  loading: true,
                  error: false,
                  load: false,
                  data: []
                }
              });

              try {
                if (apiCaller) {
                  apiCaller.cancel();
                }

                apiCaller = services["search"].suggest(text, fields, cityId);
                apiCaller.then(function (response) {
                  dispatch({
                    type: SUGGESTION_LOAD,
                    payload: {
                      loading: false,
                      error: false,
                      load: true,
                      data: response
                    }
                  });
                  apiCaller = null;
                });
              } catch (error) {
                dispatch({
                  type: SUGGESTION_ERROR,
                  payload: {
                    loading: false,
                    error: error,
                    load: true,
                    data: []
                  }
                });
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var suggestion_getSuggestionWithTabId = function getSuggestionWithTabId(text, fields, cityId, tabId) {
  return /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(dispatch) {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch({
                type: SUGGESTION_LOADING,
                payload: {
                  loading: true,
                  error: false,
                  load: false,
                  data: []
                }
              });

              try {
                if (apiCaller) {
                  apiCaller.cancel();
                }

                apiCaller = services["search"].suggest(text, fields, cityId, tabId);
                apiCaller.then(function (response) {
                  // services module has to be fixed asap. There must be 'throw' instead of 'return' for errors.
                  if (response instanceof Error) {
                    dispatch({
                      type: SUGGESTION_ERROR,
                      payload: {
                        loading: false,
                        error: response,
                        load: true,
                        data: []
                      }
                    });
                    return;
                  }

                  dispatch({
                    type: SUGGESTION_LOAD,
                    payload: {
                      loading: false,
                      error: false,
                      load: true,
                      data: response
                    }
                  });
                  apiCaller = null;
                });
              } catch (error) {
                dispatch({
                  type: SUGGESTION_ERROR,
                  payload: {
                    loading: false,
                    error: error,
                    load: true,
                    data: []
                  }
                });
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var suggestion_getSuggestionWithoutTabId = function getSuggestionWithoutTabId(text, cityId) {
  var categoryId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var tradeTypeId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var useTab = arguments.length > 4 ? arguments[4] : undefined;
  return /*#__PURE__*/function () {
    var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3(dispatch) {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch({
                type: SUGGESTION_LOADING,
                payload: {
                  loading: true,
                  error: false,
                  load: false,
                  data: []
                }
              });

              try {
                if (useTab === 'Emlak Ofisleri') {
                  apiCaller = Object(account["c" /* getSearchForAgent */])(text);
                  apiCaller.then(function (response) {
                    var res = response && response.result.suggestions;

                    if (!res) {
                      dispatch({
                        type: SUGGESTION_ERROR,
                        payload: {
                          loading: false,
                          error: response.error,
                          load: true,
                          data: []
                        }
                      });
                      return;
                    }

                    dispatch({
                      type: SUGGESTION_LOAD,
                      payload: {
                        loading: false,
                        error: false,
                        load: true,
                        data: res
                      }
                    });
                    apiCaller = null;
                  });
                } else {
                  apiCaller = getSearchWithSuggestion({
                    text: text,
                    cityId: cityId,
                    categoryId: categoryId,
                    tradeTypeId: tradeTypeId
                  });
                  apiCaller.then(function (response) {
                    // services module has to be fixed asap. There must be 'throw' instead of 'return' for errors.
                    if (response.status !== 'success') {
                      dispatch({
                        type: SUGGESTION_ERROR,
                        payload: {
                          loading: false,
                          error: response,
                          load: true,
                          data: []
                        }
                      });
                      return;
                    }

                    var suggestionData = convertSuggestionDataForFilterBox(response);
                    dispatch({
                      type: SUGGESTION_LOAD,
                      payload: {
                        loading: false,
                        error: false,
                        load: true,
                        data: suggestionData
                      }
                    });
                    apiCaller = null;
                  });

                  if (useTab === 'Projeler') {
                    apiCaller = getSearchWithProjectSuggestion({
                      text: text
                    });
                    apiCaller.then(function (response) {
                      if (response.status !== 'success') {
                        dispatch({
                          type: SUGGESTION_ERROR,
                          payload: {
                            loading: false,
                            error: response,
                            load: true,
                            data: []
                          }
                        });
                        return;
                      }

                      var suggestionData = convertSuggestionDataForFilterBox(response);
                      dispatch({
                        type: SUGGESTION_LOAD,
                        payload: {
                          loading: false,
                          error: false,
                          load: true,
                          data: suggestionData
                        }
                      });
                      apiCaller = null;
                    });
                  }
                }
              } catch (error) {
                dispatch({
                  type: SUGGESTION_ERROR,
                  payload: {
                    loading: false,
                    error: error,
                    load: true,
                    data: []
                  }
                });
              }

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
// CONCATENATED MODULE: ./src/redux-store/containers/suggestion/index.js
/**
 * Import search actions.
 */

/**
 * Map action list to the connected component's props by dispatching.
 */

var mapDispatchToProps = {
  callSuggestion: suggestion_getSuggestion,
  callSuggestionWithTabId: suggestion_getSuggestionWithTabId,
  callSuggestionWithoutTabId: suggestion_getSuggestionWithoutTabId
};
/**
 * Map selected state objects to the connected component's props.
 */

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    suggestionData: state.suggestion.data,
    favoriteList: state.favorites.favoriteList,
    favoriteListings: state.favorites.favoriteListings
  };
}; // Export mappers.


/* harmony default export */ var suggestion = __webpack_exports__["a"] = ([mapStateToProps, mapDispatchToProps]);

/***/ })

}]);